import Card from '@mui/material/Card'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import { t } from 'i18next'

const TrainingNotFound = () => (
  <Container>
    <Card sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 300 }}>
      <Typography textAlign="center" variant="h5">
        {t('errors.training_not_found')}
      </Typography>
    </Card>
  </Container>
)

export default TrainingNotFound
